var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.savvyEnabledLoggedOutHomepage
    ? _c(
        "Landing",
        { staticClass: "homepage" },
        [
          _c("Banner"),
          _vm._v(" "),
          _c("LandingHeaderV2", {
            attrs: {
              "ax-params": {
                ids: {
                  headerLogInBtn: "clicked_login_from_header",
                  stickyHeaderSignUpBtn: "clicked_start_free_trial_from_home",
                  stickyHeaderLogInBtn: "clicked_login_from_home"
                }
              }
            }
          }),
          _vm._v(" "),
          _c("LandingHeroV2", {
            staticClass: "logged-out",
            attrs: {
              "video-url":
                "/site_media/version-V87e099514e4/images/homepage/landingpage_cs.mp4",
              "cta-ax-params": {
                axId: "clicked_start_free_trial_from_home_hero",
                axType: "button"
              },
              "cta-button-text": "Get started",
              isExperiment: _vm.isExperiment
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function() {
                    return [
                      _vm._v("\n      The best way to learn\n      "),
                      _c("EmphasisText", [_vm._v("math and computer science")])
                    ]
                  },
                  proxy: true
                },
                {
                  key: "intro-text",
                  fn: function() {
                    return [
                      _vm._v(
                        "\n      Guided interactive problem solving that's effective and fun. Master concepts in 15 minutes a\n      day.\n    "
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3667739372
            )
          }),
          _vm._v(" "),
          _c("Summary", { attrs: { isExperiment: _vm.isExperiment } }),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "divider" })
          ]),
          _vm._v(" "),
          _c("LearningPaths", {
            attrs: {
              isExperiment: _vm.isExperiment,
              "ax-id-prefix": "homepage"
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "heading",
                  fn: function() {
                    return [
                      _c("h3", { staticClass: "title" }, [
                        _vm._v("Guided courses for every journey")
                      ])
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3124524505
            )
          }),
          _vm._v(" "),
          !_vm.isExperiment
            ? [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "divider" })
                ]),
                _vm._v(" "),
                _c("PrinciplesOfLearning")
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "divider" })
          ]),
          _vm._v(" "),
          _c("JoinCTA", {
            attrs: {
              isExperiment: _vm.isExperiment,
              "btn-ax-id": "clicked_start_free_trial_from_home_footer"
            }
          }),
          _vm._v(" "),
          _c("LandingFooter"),
          _vm._v(" "),
          _vm.show_sponsor_modal ? _c("SponsorModal") : _vm._e(),
          _vm._v(" "),
          _c("JoinClassroomModal"),
          _vm._v(" "),
          _vm.isPbsNovaTraffic ? _c("NovaSponsorModal") : _vm._e(),
          _vm._v(" "),
          !_vm.privacyProperties.viewed_privacy_banner
            ? _c("PrivacyBanner")
            : _vm._e(),
          _vm._v(" "),
          _vm.show_just_deactivated_account_message
            ? _c("AccountDeactivatedModal")
            : _vm._e(),
          _vm._v(" "),
          _c("ChurnTrackingBlock"),
          _vm._v(" "),
          _vm.showReferAFriendModal
            ? _c("ReferAFriendModal", {
                attrs: {
                  as: "referee",
                  "free-months-count": _vm.referralModalInfoData.free_months,
                  "referrer-name": _vm.referralModalInfoData.referrer_name
                },
                on: { close: _vm.closeReferAFriendModal }
              })
            : _vm._e()
        ],
        2
      )
    : _c("SavvyFlow", { attrs: { "flow-id": _vm.loggedOutHomepageFlowId } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }